//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchItemDropdown from '@/components/search/SearchItemDropdown'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'SkillsDropdown',
  components: {
    SearchItemDropdown
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    category: {
      type: Number,
      default: null
    },
    skill: {
      type: Number,
      default: null
    }
  },
  computed: {
    skills () {
      if (this.category) {
        return this.$store.getters['util/getSkillsByCategory'](this.category)
      }

      return []
    },
    skillName () {
      if (this.skill) {
        return this.skills.find(s => s.id === this.skill)?.name
      }
      return null
    }
  },
  methods: {
    selectSkill (c) {
      this.$emit('select', c.id)
    },

    removeSkill () {
      this.$emit('select', null)
    }
  }
}
